import { Button, Checkbox, FormControlLabel, FormHelperText } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { AVAILABLE_PLATFORMS } from "../constants/platforms";

// Action button styling for consistency
const buttonStyle = { p: 1, fontSize: "11px" };

/**
 * PlatformSelection component for selecting platforms for geocoder tasks.
 *
 * @param {Object} props - The properties passed to the component.
 * @param {Array} props.selectedPlatforms - Currently selected platforms.
 * @param {Function} props.onPlatformChange - Callback when platforms selection changes.
 *
 * @returns {JSX.Element} - The JSX element for platform selection.
 */
const PlatformSelection = ({ selectedPlatforms, onPlatformChange }) => {
  const togglePlatform = (platform) => {
    const newSelectedPlatforms = selectedPlatforms.includes(platform)
      ? selectedPlatforms.filter((p) => p !== platform)
      : [...selectedPlatforms, platform];
    onPlatformChange(newSelectedPlatforms);
  };

  const selectAll = () => {
    onPlatformChange(AVAILABLE_PLATFORMS);
  };

  const deselectAll = () => {
    onPlatformChange([]);
  };

  return (
    <>
      <Grid container spacing={2}>
        {AVAILABLE_PLATFORMS.map((platform) => (
          <Grid size={{ xs: 12, sm: 6, md: 3 }} key={platform}>
            <FormControlLabel
              control={
                <Checkbox checked={selectedPlatforms.includes(platform)} onChange={() => togglePlatform(platform)} />
              }
              label={platform}
            />
          </Grid>
        ))}
      </Grid>

      <Grid container spacing={1} direction="row" sx={{ py: 2 }}>
        <Grid>
          <Button sx={buttonStyle} variant="outlined" size="small" onClick={selectAll}>
            Select All
          </Button>
        </Grid>
        <Grid>
          <Button sx={buttonStyle} variant="outlined" size="small" onClick={deselectAll}>
            Deselect All
          </Button>
        </Grid>
      </Grid>

      <FormHelperText>Select platforms to include in the geocoder task</FormHelperText>
    </>
  );
};

export default PlatformSelection;
